import { useTutorial } from './context';

/**
 * Returns the narration text of the currently playing tutorial step, or
 * `null` when no step's audio is currently active.
 */
export const useTutorialStepText = (): string | null => {
  const { activeStepText } = useTutorial();

  return activeStepText;
};
